import DealerInvitedNoData from './dealerInvited';

export default DealerInvitedNoData;